"use strict";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, Text, TouchableArea, isWeb } from "ui/src";
import { openUri } from "utils/linking";
import { isMobileApp } from "utilities/src/platform";
const onPressLearnMore = (url) => openUri(url);
export const LearnMoreLink = ({
  url,
  textVariant = "buttonLabel2",
  textColor = "$accent1",
  centered = false,
  display,
  componentType = "TouchableArea",
  hoverStyle
}) => {
  const { t } = useTranslation();
  const handleOnPress = useCallback(() => onPressLearnMore(url), [url]);
  if (componentType === "Button") {
    return <Button size={isWeb ? "medium" : "large"} emphasis="text-only" onPress={handleOnPress}>
        <Button.Text color={textColor}>{t("common.button.learn")}</Button.Text>
      </Button>;
  }
  return isMobileApp ? <Text color={textColor} variant={textVariant} textAlign={centered ? "center" : void 0} onPress={handleOnPress}>
      {t("common.button.learn")}
    </Text> : <TouchableArea display={display} style={{ textAlign: centered ? "center" : "left" }} onPress={handleOnPress}>
      <Text color={textColor} variant={textVariant} hoverStyle={hoverStyle}>
        {t("common.button.learn")}
      </Text>
    </TouchableArea>;
};
